export class FsxVolumeBackupInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "volumeId",
            "baseName": "volumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "sizeBytes",
            "baseName": "sizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "junctionPath",
            "baseName": "junctionPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "volumeType",
            "baseName": "volumeType",
            "type": "string",
            "format": ""
        },
        {
            "name": "recoveryPointArn",
            "baseName": "recoveryPointArn",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FsxVolumeBackupInfo.attributeTypeMap;
    }
    constructor() {
    }
}
